import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

export abstract class AuthGuard implements CanActivate {
  abstract canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot);
}
